import React from 'react';

import { Typography, Container, Paper } from '@material-ui/core';
import PropTypes from 'prop-types';

import Jumbotron from '../Jumbotron';

import useStyles from './DialogViewWrapper.styles';

const DialogViewWrapper = ({ children, title, contentSize, noCardPadding, maxWidth, onBack, contentClassName }) => {
  const styles = useStyles({ contentSize, noCardPadding });

  return (
    <Container className={styles.wrapper} maxWidth={maxWidth}>
      <Jumbotron background='white' onBack={onBack} showBackButton>
        <Typography align='center' component='h1' variant='h1'>
          {title}
        </Typography>
      </Jumbotron>
      <Paper className={contentClassName ? `${styles.content} ${contentClassName}` : styles.content}>{children}</Paper>
    </Container>
  );
};

DialogViewWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  contentSize: PropTypes.string,
  noCardPadding: PropTypes.bool,
  maxWidth: PropTypes.string,
  onBack: PropTypes.func,
  contentClassName: PropTypes.string,
};

DialogViewWrapper.defaultProps = {
  contentSize: 'sm',
  maxWidth: 'md',
  noCardPadding: false,
  onBack: undefined,
  contentClassName: undefined,
};

export default DialogViewWrapper;
